import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './App.css';
import Footer from './Footer.js';
import Header from './Header.js';
import Home from './Home.js';
import About from './About.js';
import Contact from './Contact.js';
import Checkout from './Checkout.jsx';
import Viewcart from './Viewcart.jsx';
import ShippingDelivery from './ShippingDelivery.jsx';
import TermsCondition from './TermsCondition.jsx';
import PrivacyPolicy from './PrivacyPolicy.jsx';
import Progress from './component/Progress.jsx';
import BottomToolBar from './component/BottomToolBar.jsx';
import OffCanvasMenu from './component/OffCanvasMenu.jsx';
import Login from './Login.jsx';
import WishList from './WishList.jsx';
import Faq from './Faq.jsx';
import OurStore from './OurStore.jsx';
import LoginModel from './component/LoginModel.jsx';
import Register from './Register.jsx';
import ProductDetail from './ProductDetail.js';
import MyAccount from './MyAccount.jsx';
import MyAccountOrders from './MyAccountOrders.jsx';
import MyAccountAddress from './MyAccountAddress.jsx';
import MyAccountDetails from './MyAccountDetails.jsx';
import ShoppingList from './ShoppingList.js';
import AuthProvider from './hooks/AuthProvider.jsx';
import ApiStoreProvider from './hooks/ApiStoreContext.jsx';
import MyAccountOrderDetails from './MyAccountOrderDetails.jsx';
import { CartProvider } from './hooks/CartContext.jsx';

function App() {
  return (
    <>
      <Router>
        <AuthProvider>
          <ApiStoreProvider>
            <CartProvider>
              <div id="wrapper">
                {/* <TopBar /> */}
                <Header />
                <Routes>
                  <Route exact path="/" element={<Home />} />
                  <Route path="/shop" element={<ShoppingList />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/login" element={<Login />} />
                  <Route path="/register" element={<Register />} />
                  <Route path="/view-cart" element={<Viewcart />} />
                  <Route path="/check-out" element={<Checkout />} />
                  <Route path="/shipping-delivery" element={<ShippingDelivery />} />
                  <Route path="/terms-conditions" element={<TermsCondition />} />
                  <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                  <Route path="/wishlist" element={<WishList />} />
                  <Route path="/faq" element={<Faq />} />
                  <Route path="/our-store" element={<OurStore />} />
                  <Route path='/my-account' element={<MyAccount />} />
                  <Route path='/my-account-orders' element={<MyAccountOrders />} />
                  <Route path='/my-account-order-details' element={<MyAccountOrderDetails />} >
                    <Route path='/my-account-order-details/:orderId' />
                  </Route>
                  <Route path='/my-account-address' element={<MyAccountAddress />} />
                  <Route path='/my-account-edit' element={<MyAccountDetails />} />
                  <Route path="/productDetail" element={<ProductDetail />} />
                </Routes>
                <Footer />
              </div>
              <Progress />
              {/* <BottomToolBar /> */}
              <OffCanvasMenu />
              <LoginModel />
            </CartProvider>
          </ApiStoreProvider>
        </AuthProvider>
      </Router >
    </>

  );
}

export default App;